import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

const Password = ({ label, value, onChange, ...rest }) => (
  <TextField
    label={label}
    variant='outlined'
    value={value}
    onChange={(e) => _.isFunction(onChange) && onChange(e.target.value)}
    {...rest}
  />
);

Password.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default Password;
